import React from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  IconButton,
} from '@mui/material';
import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';
import { ClinicInfoFormData } from './clinicHelper';
import { ReactComponent as EditIcon } from '../../../src/assets/SVG/editIconSvg.svg';
import { ReactComponent as ViewIcon } from '../../../src/assets/SVG/viewIconSvg.svg';
import { getButtonStates } from '../../utils/permissionService';
interface Props {
  clinics: ClinicInfoFormData[];
  onEdit?: (clinic: ClinicInfoFormData) => void;
  onView?: (clinic: ClinicInfoFormData) => void;

}

const ClinicTable: React.FC<Props> = ({clinics,onEdit,onView,}) => {
  const { t: tClinic } = useTranslation('clinic_config');
  const { canEdit, canAdd } = getButtonStates('Settings', 'Configuration', 'Clinic');

  return (
    <>
    
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ width: '100%', borderRight: 'none', padding: 0 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#fafafa' }}>
              <TableCell>
                <strong>{tClinic('ClinicList_Page.Text_TableHeaders.clinicName') || 'Clinic Name'}</strong>
              </TableCell>
              <TableCell>
                <strong>{tClinic('ClinicList_Page.Text_TableHeaders.code') || 'Code'}</strong>
              </TableCell>
              <TableCell>
                <strong>{tClinic('ClinicList_Page.Text_TableHeaders.tableStatus') || 'Status'}</strong>
              </TableCell>

              {(canAdd || canEdit) && (

                <TableCell align="center">
                  <strong>{tClinic('ClinicList_Page.Text_TableHeaders.actions') || 'Actions'}</strong>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {clinics.map((clinic, idx) => (
              <TableRow key={clinic.id ?? idx}>
                <TableCell>{clinic.name}</TableCell>
                <TableCell>{clinic.code}</TableCell>
                <TableCell>
                  {clinic.is_active ? (
                    <Chip
                      label="Active"
                      variant="outlined"
                      size="small"
                      sx={{
                        color: '#43a047',
                        borderColor: '#43a047',
                        fontWeight: 600,
                        letterSpacing: 0.5,
                        px: 2
                      }}
                    />
                  ) : (
                    <Chip
                      label="Inactive"
                      variant="outlined"
                      size="small"
                      sx={{
                        color: '#e53935',
                        borderColor: '#e53935',
                        fontWeight: 600,
                        letterSpacing: 0.5,
                        px: 2
                      }}
                    />
                  )}
                </TableCell>
                {(canAdd || canEdit) && (

                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() => onEdit && onEdit(clinic)}
                      sx={{ mr: 1 }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="primary"
                      onClick={() => onView && onView(clinic)}
                    >
                      <ViewIcon />
                    </IconButton>
                  </TableCell>
                )} 
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ClinicTable;